module.exports = __webpack_public_path__ + "static/media/Slice7.2584d38e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_151/img/Slice7.png
// module id = 1488
// module chunks = 0